/* Generated from Java with JSweet 2.3.7 - http://www.jsweet.org */
import { NodeCompat } from '../../../compat/NodeCompat';
import { ExternalDocumentation } from '../../../core/models/common/ExternalDocumentation';
import { IServerParent } from '../../../core/models/common/IServerParent';
import { Server } from '../../../core/models/common/Server';
import { OasOperation } from '../../models/OasOperation';
import { OasParameter } from '../../models/OasParameter';
import { OasResponses } from '../../models/OasResponses';
import { OasSecurityRequirement } from '../../models/OasSecurityRequirement';

/**
 * Constructor.
 * @param {string} method
 * @class
 * @extends OasOperation
 * @author eric.wittmann@gmail.com
 */
export class Oas30Operation extends OasOperation implements IServerParent {
    public requestBody : Oas30RequestBody;

    public callbacks : any;

    public servers : Array<Server>;

    public constructor(method : string) {
        super(method);
        if(this.requestBody===undefined) this.requestBody = null;
        this.callbacks = <any>({});
        if(this.servers===undefined) this.servers = null;
    }

    /**
     * @see io.apicurio.datamodels.core.models.common.Operation#createExternalDocumentation()
     * @return {ExternalDocumentation}
     */
    public createExternalDocumentation() : ExternalDocumentation {
        let externalDocs : ExternalDocumentation = new Oas30ExternalDocumentation();
        externalDocs._ownerDocument = this.ownerDocument();
        externalDocs._parent = this;
        return externalDocs;
    }

    /**
     * @see io.apicurio.datamodels.openapi.models.OasOperation#createParameter()
     * @return {OasParameter}
     */
    public createParameter() : OasParameter {
        let param : OasParameter = new Oas30Parameter();
        param._ownerDocument = this.ownerDocument();
        param._parent = this;
        return param;
    }

    /**
     * @see io.apicurio.datamodels.openapi.models.OasOperation#createResponses()
     * @return {OasResponses}
     */
    public createResponses() : OasResponses {
        let responses : OasResponses = new Oas30Responses();
        responses._ownerDocument = this.ownerDocument();
        responses._parent = this;
        return responses;
    }

    /**
     * @see io.apicurio.datamodels.openapi.models.OasOperation#createSecurityRequirement()
     * @return {OasSecurityRequirement}
     */
    public createSecurityRequirement() : OasSecurityRequirement {
        let requirement : OasSecurityRequirement = new Oas30SecurityRequirement();
        requirement._ownerDocument = this.ownerDocument();
        requirement._parent = this;
        return requirement;
    }

    /**
     * Creates a callback.
     * @param {string} name
     * @return {Oas30Callback}
     */
    public createCallback(name : string) : Oas30Callback {
        let rval : Oas30Callback = new Oas30Callback(name);
        rval._ownerDocument = this.ownerDocument();
        rval._parent = this;
        return rval;
    }

    /**
     * Adds a callback.
     * @param {string} name
     * @param {Oas30Callback} callback
     */
    public addCallback(name : string, callback : Oas30Callback) {
        /* put */(this.callbacks[name] = callback);
    }

    /**
     * Gets a single callback by name.
     * @param {string} name
     * @return {Oas30Callback}
     */
    public getCallback(name : string) : Oas30Callback {
        return /* get */((m,k) => m[k]===undefined?null:m[k])(this.callbacks, name);
    }

    /**
     * Removes a single callback and returns it.  This may return null or undefined if none found.
     * @param {string} name
     * @return {Oas30Callback}
     */
    public removeCallback(name : string) : Oas30Callback {
        return /* remove */(map => { let deleted = this.callbacks[name];delete this.callbacks[name];return deleted;})(this.callbacks);
    }

    /**
     * Gets a list of all callbacks.
     * @return {Oas30Callback[]}
     */
    public getCallbacks() : Array<Oas30Callback> {
        let rval : Array<Oas30Callback> = <any>([]);
        /* addAll */((l1, l2) => l1.push.apply(l1, l2))(rval, /* values */(obj => Object.keys(obj).map(key => obj[key]))(this.callbacks));
        return rval;
    }

    /**
     * Creates a child RequestBody model.
     * @return {Oas30RequestBody}
     */
    public createRequestBody() : Oas30RequestBody {
        let rval : Oas30RequestBody = new Oas30RequestBody();
        rval._ownerDocument = this.ownerDocument();
        rval._parent = this;
        return rval;
    }

    /**
     * @see io.apicurio.datamodels.core.models.common.IServerParent#createServer()
     * @return {Server}
     */
    public createServer() : Server {
        let rval : Oas30Server = new Oas30Server();
        rval._ownerDocument = this.ownerDocument();
        rval._parent = this;
        return rval;
    }

    /**
     * @see io.apicurio.datamodels.core.models.common.IServerParent#addServer(io.apicurio.datamodels.core.models.common.Server)
     * @param {Server} server
     */
    public addServer(server : Server) {
        if(this.servers == null) {
            this.servers = <any>([]);
        }
        /* add */(this.servers.push(<Oas30Server>server)>0);
    }

    /**
     * @see io.apicurio.datamodels.core.models.common.IServerParent#getServer(java.lang.String)
     * @param {string} url
     * @return {Server}
     */
    public getServer(url : string) : Server {
        if(this.servers != null) {
            for(let index163=0; index163 < this.servers.length; index163++) {
                let server = this.servers[index163];
                {
                    if(NodeCompat.equals(server.url, url)) {
                        return server;
                    }
                }
            }
        }
        return null;
    }

    /**
     * @see io.apicurio.datamodels.core.models.common.IServerParent#getServers()
     * @return {Server[]}
     */
    public getServers() : Array<Server> {
        return this.servers;
    }
}
Oas30Operation["__class"] = "io.apicurio.datamodels.openapi.v3.models.Oas30Operation";
Oas30Operation["__interfaces"] = ["io.apicurio.datamodels.core.models.common.ISecurityRequirementParent","io.apicurio.datamodels.core.models.IVisitable","io.apicurio.datamodels.openapi.models.IOasParameterParent","io.apicurio.datamodels.core.models.common.IExternalDocumentationParent","io.apicurio.datamodels.core.models.common.IServerParent"];





import { Oas30Server } from './Oas30Server';


import { Oas30SecurityRequirement } from './Oas30SecurityRequirement';


import { Oas30Responses } from './Oas30Responses';


import { Oas30Parameter } from './Oas30Parameter';


import { Oas30ExternalDocumentation } from './Oas30ExternalDocumentation';


import { Oas30Callback } from './Oas30Callback';


import { Oas30RequestBody } from './Oas30RequestBody';

